import React, { useEffect, useState } from 'react';
import { useGetOTPQuery } from 'entities/sendOTP';
import { useDefaultSendOTPTableValues } from 'widgets/sendOTP/lib';
import { DataTableSwitch } from 'shared/ui/Table';
import { columnConfig } from 'widgets/sendOTP/model';
import { useAppSelector } from 'app/store';
import { setDrawerOpen } from 'features/ui/model/uiSlice';
import { useDispatch } from 'react-redux';
import { CreateOtpDrawer } from 'widgets/sendOTP/ui/CreateOTPDrawer';
import { UpdateOtpDrawer } from 'widgets/sendOTP/ui/UpdateOTPDrawer';
import { OTPDataItemTableType } from 'entities/sendOTP/types';
import { DeleteOtpDrawer } from 'widgets/sendOTP/ui/DeleteOTPDrawer';
import { useGetCountriesQuery } from 'features/getCountries/api/getCountriesApi';
import { useCacheData } from 'shared/hooks';
import { CountriesType } from 'entities/distribution/types';

type DrawerComponentsType = {
  [key: string]: React.ReactNode;
};

export const SendOtpTable = () => {
  const dispatch = useDispatch();
  const { isDrawerOpen } = useAppSelector((state) => state.ui);
  const [drawerVariant, setDrawerVariant] = useState<{ variant: string; data: OTPDataItemTableType | number | null }>({
    variant: 'create',
    data: null,
  });
  const drawerComponents: DrawerComponentsType = {
    create: <CreateOtpDrawer />,
    update: <UpdateOtpDrawer data={drawerVariant.data as OTPDataItemTableType} />,
    delete: <DeleteOtpDrawer id={drawerVariant.data as number} />,
  };

  useEffect(() => {
    if (!isDrawerOpen) {
      setDrawerVariant({
        variant: 'create',
        data: null,
      });
    }
  }, [isDrawerOpen]);

  const { data: otpList } = useGetOTPQuery(null);
  const { data: countiesList } = useGetCountriesQuery(null);

  const tableData = useDefaultSendOTPTableValues(otpList || []);
  const cachedCountries = useCacheData<CountriesType>(countiesList as CountriesType[]) || [];

  const handleDrawerAdd = (variant: string, data: OTPDataItemTableType | number | null) => {
    setDrawerVariant({
      variant,
      data,
    });

    dispatch(setDrawerOpen(true));
  };

  const onRowClick = (data: OTPDataItemTableType) => {
    handleDrawerAdd('update', data);
  };

  const handleDrawerDelete = (data: OTPDataItemTableType) => {
    handleDrawerAdd('delete', data.id);
  };

  return (
    <>
      {tableData.map((data) => (
        <DataTableSwitch
          style={{ marginTop: '50px' }}
          title={cachedCountries[Number(data.countryId)]?.name}
          columnConfig={columnConfig}
          onRowClick={(data) => onRowClick(data)}
          data={data.data}
          handleDrawerDelete={handleDrawerDelete}
          deleteIcon
          variantDrawer="deleteSend"
          titleDrawer="Удалить город"
        />
      ))}
      {drawerVariant.variant in drawerComponents && <div>{drawerComponents[drawerVariant.variant]}</div>}
    </>
  );
};
